import { useMemo, lazy, Suspense } from 'react'
import { useCritterStore } from '../store/critterStore'
import useSettingsStore from '../store/settingsStore'
import Critter from './Critter'
import '../styles/CritterContainer.css'

// Lazy load the 3D canvas to avoid loading Three.js when not needed
const ThreeDCritterCanvas = lazy(() => import('./three/ThreeDCritterCanvas'))

function CritterContainer() {
  const critters = useCritterStore((state) => state.critters)
  const critterTypes = useCritterStore((state) => state.critterTypes)
  const enable3D = useSettingsStore((state) => state.settings.enable3D)

  const critterList = Object.values(critters)

  // Split critters into 2D and check if any 3D exist
  const { twoDCritters, has3D } = useMemo(() => {
    const twoD = []
    let threeD = false

    critterList.forEach((c) => {
      if (enable3D && critterTypes[c.critterType]?.renderMode === '3d') {
        threeD = true
      } else {
        twoD.push(c)
      }
    })

    return { twoDCritters: twoD, has3D: threeD }
  }, [critterList, critterTypes, enable3D])

  return (
    <>
      {/* 3D canvas - only mounted when 3D critters exist */}
      {has3D && (
        <Suspense fallback={null}>
          <ThreeDCritterCanvas critters={critterList} critterTypes={critterTypes} />
        </Suspense>
      )}

      {/* 2D critters */}
      <div className="critter-container">
        {twoDCritters.map((critter) => (
          <Critter key={critter.userId} critter={critter} />
        ))}
      </div>
    </>
  )
}

export default CritterContainer
